import { render, staticRenderFns } from "./VesselsByGeneratorMakeModel.vue?vue&type=template&id=2a210ec4&"
import script from "./VesselsByGeneratorMakeModel.vue?vue&type=script&lang=js&"
export * from "./VesselsByGeneratorMakeModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports